// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2yT4Q","additionalInfo":"AgreementModal_additionalInfo__3Q2fO"};